import { AdminStationResponse, AdminStationStatus } from '@mol-limo-reg/admin-api';

export type Station = AdminStationResponse;

export { AdminStationStatus };

export function mapStatusToDisplay(status: AdminStationStatus): string {
  return status === AdminStationStatus.AVAILABLE ? 'Elérhető' : 'Nem elérhető';
}

export function mapDisplayToStatus(display: string): AdminStationStatus {
  return display === 'Elérhető' ? AdminStationStatus.AVAILABLE : AdminStationStatus.NOT_AVAILABLE;
}
